import { render } from "./commandedetails.vue?vue&type=template&id=51e59bfc"
import script from "./commandedetails.vue?vue&type=script&lang=js"
export * from "./commandedetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__